export default __webpack_public_path__ + "static/media/icon-start.1edc76b9.svg";